<div class="container_width">
  <div class="w-full flex flex-column gap-3">
    <h1 class="text-left font-bold text-4xl">Dashboard</h1>
    <div class="w-full flex flex-column gap-3">
      <h2 class="text-left font-medium text-2xl" style="color: #303030;">Search</h2>
      <div class="grid">
        <div class="col-12 lg:col-2 flex flex-column gap-1">
          <b class="font-regular text-base" style="color: #505050;">From Date</b>
          <p-calendar [(ngModel)]="fromDate" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay"
            class="w-full" styleClass="fullWidth" />
        </div>
        <div class="col-12 lg:col-2 flex flex-column gap-1">
          <b class="font-regular text-base" style="color: #505050;">To Date</b>
          <p-calendar [(ngModel)]="toDate" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay"
            class="w-full" styleClass="fullWidth" />
        </div>
        <div class="col-12 lg:col-3 flex flex-column gap-1">
          <b class="font-regular text-base" style="color: #505050;">Email</b>
          <p-autoComplete [(ngModel)]="studentEmail" [suggestions]="studentEmailSuggestions" optionValue="email"
            optionLabel="email" (completeMethod)="onStudentEmailQuery($event)" [minLength]="3"
            placeholder="Search by email..." class="w-full" styleClass="fullWidth" [style]="{'width':'100%'}"
            [inputStyle]="{'width':'100%'}" emptyMessage="No matching found">
          </p-autoComplete>
        </div>
        <div class="col-12 lg:col-3 flex flex-column gap-1">
          <b class="font-regular text-base" style="color: #505050;">Student Name</b>
          <p-autoComplete [(ngModel)]="studentName" [suggestions]="studentNameSuggestions" field="name"
            (completeMethod)="onStudentNameQuery($event)" [minLength]="3" placeholder="Search by student name..."
            class="w-full" styleClass="fullWidth" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
            emptyMessage="No matching found">
          </p-autoComplete>
        </div>
        <div class="col-12 lg:col-2">
          <div class="w-full" style="padding-top: 23px;">
            <p-button (click)="onSearch()" label="Search" class="w-full" styleClass="submitBtn" />
          </div>
        </div>
      </div>
    </div>

    <div class="w-full">
      <p-table *ngIf="mentorStudents && mentorStudents.length > 0; else noRecordsFound" [value]="mentorStudents"
        [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [first]="first" [lazy]="true"
        [lazyLoadOnInit]="false" [loading]="isLoading" [loadingIcon]="'pi pi-spinner'" (onLazyLoad)="onLazyLoad($event)"
        [rowsPerPageOptions]="[10, 20, 30]" [showPageLinks]="true" styleClass="p-datatable-gridlines tableCon"
        [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th>Student Name</th>
            <th>Email Address</th>
            <th>Course</th>
            <th>Country</th>
            <th>Notes</th>
            <th>Actions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-student>

          <tr>
            <td>{{student.firstName}} {{student.lastName}}</td>
            <td>{{student.email}}</td>
            <td>{{student.intendedMajor}}</td>
            <td>{{getCountryName(student.homeCountry)}}</td>
            <td>
              <div [innerHTML]="student.mentorNotesForStudent"></div>
            </td>
            <td>
              <p-button class="px-1" (click)="viewProfile(student.id)" label="View Profile" icon="pi pi-user"
                styleClass="join" />
              <p-button class="px-1" label="Add Note" icon="pi pi-plus-circle" styleClass="resch"
                (onClick)="openAddNoteDialog(student.id)" />
              <p-button class="px-1" label="View Notes" icon="pi pi-eye" styleClass="resch"
                (onClick)="openViewNotesDialog(student.id)" />
              <p-button class="px-1" label="Schedule Call" icon="pi pi-phone" styleClass="resch"
                (onClick)="openUrl(student.eventScheduleUri)" />
            </td>
          </tr>
        </ng-template>
      </p-table>
      <ng-template #noRecordsFound>
        <div class="w-full flex flex-column align-items-center py-4 gap-5">
          <div class="w-full flex align-items-center justify-content-center">
            <img src="../../../assets/icons/nodatafound.svg" alt="" class="w-full max-w-16rem">
          </div>
          <b class="text-center font-normal text-2xl" style="color: #000086;">No Data Found !</b>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<!-- ADD NOTE DIALOG -->
<p-dialog [(visible)]="addNoteVisible" [modal]="true" [style]="{ width: '55rem' }"
  [contentStyle]="{ 'overflow': 'visible' }">
  <ng-template pTemplate="header">
    <span class="font-bold">Add New Note</span>
  </ng-template>

  <div class="flex flex-column gap-3">
    <!-- Date Picker -->
    <div class="flex align-items-center gap-3">
      <b style="color: #505050; white-space: nowrap;">Select Date</b>
      <p-calendar [(ngModel)]="newNoteDate" [showIcon]="true" [iconDisplay]="'input'" dateFormat="mm/dd/yy"
        appendTo="body" [showOnFocus]="true" [readonlyInput]="true" placeholder="MM/DD/YYYY"
        [style]="{'width': '406px'}" [panelStyle]="{'width': 'auto', 'min-width': '280px'}" />
    </div>

    <!-- Rich Text Editor -->
    <div class="flex flex-column gap-1">
      <b style="color: #505050;">Note</b>
      <p-editor [(ngModel)]="newNoteText" [style]="{ height: '180px' }" placeholder="Enter your notes here...">
      </p-editor>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button label="Cancel" severity="secondary" styleClass="cancelBtn" (onClick)="addNoteVisible = false" />
    <p-button label="Save Note" icon="pi pi-check" styleClass="confirmBtn" [disabled]="!newNoteText || !newNoteDate"
      (onClick)="saveNewNote()" />
  </ng-template>
</p-dialog>

<!-- VIEW NOTES DIALOG -->
<p-dialog [(visible)]="viewNotesVisible" [modal]="true" [style]="{ width: '55rem' }">
  <ng-template pTemplate="header">
    <span class="font-bold" style="color: #000;">Student Notes History</span>
  </ng-template>

  <div class="flex flex-column gap-3" style="max-height: 500px; overflow-y: auto; overflow-x: hidden;">

    <!-- Loading State -->
    <div *ngIf="isLoadingNotes" class="flex justify-content-center py-4">
      <i class="pi pi-spinner pi-spin text-4xl" style="color: #000086;"></i>
    </div>

    <!-- No Notes Found -->
    <div *ngIf="!isLoadingNotes && studentNotesList.length === 0" class="flex justify-content-center py-4">
      <span style="color: #505050;">No notes found for this student.</span>
    </div>

    <!-- Notes List — latest first -->
    <div *ngFor="let note of studentNotesList; let i = index" class="flex gap-3 pb-3">

      <!-- Date Column (left side) -->
      <div class="flex flex-column align-items-center" style="min-width: 130px;">
        <span class="font-bold text-sm" style="color: #000086;">
          {{ formatNoteDate(note.noteDate) }}
        </span>
        <!-- Vertical line -->
        <div *ngIf="i < studentNotesList.length - 1"
          style="width: 2px; flex: 1; background: #000086; margin-top: 6px; min-height: 30px;">
        </div>
      </div>

      <!-- Note Content (right side) -->
      <div class="flex-1">
        <div style="position: relative;">
          <div [innerHTML]="note.noteText" style="background: #fffde7; border-left: 3px solid #000086;
                   padding: 10px 14px; border-radius: 4px; font-size: 14px; color: black; padding-right: 40px;">
          </div>
          <!-- Delete button for each note -->
          <span
            style="position: absolute; top: 2px; right: 8px; width: 28px; height: 28px; display:flex; align-items:center; justify-content:center;">
            <p-button icon="pi pi-trash" severity="danger" [text]="true" pTooltip="Delete" tooltipPosition="top"
              styleClass="p-0 m-0" (onClick)="deleteNote(note.id)" />
          </span>
        </div>
      </div>
    </div>

  </div>

  <ng-template pTemplate="footer">
    <p-button label="Close" styleClass="cancelBtn" (onClick)="viewNotesVisible = false" />
  </ng-template>
</p-dialog>